<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="路线类目名称">
          <el-input placeholder="请输入路线类目名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加路线类目</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" :expand-row-keys="expandRowKeys" row-key="route_category_id">
      
            <el-table-column type="expand" width="50">
              <template slot-scope="props">
                <div v-if="props.row.children && props.row.children.length > 0" style="padding-left:20px;">
                  <el-table :data="props.row.children" size="small" border>
                    <el-table-column prop="name" label="二级分类名称"></el-table-column>
                    <el-table-column prop="sort" label="排序" width="100"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
                    <el-table-column label="操作" width="120">
                      <template slot-scope="scope">
                        <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-else style="padding-left:20px;color:#999;">暂无二级分类</div>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="路线类目名称">
              <template slot-scope="scope">
                {{ scope.row.name }}
                <span v-if="scope.row.children && scope.row.children.length > 0" style="color:#409EFF;">({{ scope.row.children.length }})</span>
              </template>
            </el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" :catList="catList" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :route_category_id="route_category_id" :catList="catList" v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Route_categoryApi from '@/api/route_category.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        route_category_id:"",
        dialogVisible:false,
        catList:[],
        expandRowKeys:[],
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      this.getCatList();
    },
    methods: {
      toggleExpand(row) {
        // 现在只使用 Element UI 自带的展开列，此方法保留为空或移除
      },
      /*获取分类列表*/
      getCatList(){
        let self = this;
        Route_categoryApi.catList({}).then(data => {
          self.catList = data.data.list;
        }).catch(error => {
        });
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//路线类目标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Route_categoryApi.list(Params, true)
          .then(data => {
            self.loading = false;
            let list = data.data.list.data;
            self.tableData = list.filter(item => item.parent_id == 0 || item.parent_id == '0');
            self.totalDataNumber = self.tableData.length;
            
            // 默认展开所有有子分类的行
            self.expandRowKeys = self.tableData
              .filter(item => item.children && item.children.length > 0)
              .map(item => item.route_category_id);
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.route_category_id = row.route_category_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Route_categoryApi.del(
              {
                route_category_id: row.route_category_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/route_category/index/index.vue